const state = {
  // Список настроек прилжения
  settings: {},
};

export default state;
